
/* Swap estimated shipping message for 43 cu ft firewood (LTL freight) */
(function() {
  var LTL_VARIANT_ID = '47585087553753';
  var LTL_MESSAGE = 'LTL Freight Delivery — Scheduled delivery within 5-10 business days';
  function swapShipping() {
    var sel = document.querySelector('variant-selects, variant-radios');
    if (!sel) return;
    sel.addEventListener('change', function() {
      setTimeout(function() {
        var id = sel.querySelector('input[type="radio"]:checked');
        if (!id) { var s = sel.querySelector('select'); if (s) id = { value: s.value }; }
        if (!id) return;
        var msg = document.querySelector('.shipping-message, [data-shipping-message], .product__shipping');
        if (msg && id.value === LTL_VARIANT_ID) { msg.textContent = LTL_MESSAGE; }
      }, 100);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', swapShipping);
  else swapShipping();
})();

/* ========== Fire Video — Transparent v4 (Winter Products Only) ========== */
(function() {
  var WINTER_HANDLES = [
    'cedar-kindling-fire-starter-sticks',
    'incense-cedar-firewood',
    'fatwood-fire-starter-sticks',
    'fatwood-and-cedar-firestarter-kit'
  ];
  var path = window.location.pathname;
  var isWinterProduct = WINTER_HANDLES.some(function(h) { return path.indexOf(h) !== -1; });
  if (path.indexOf('/pages/cedar-firewood') !== -1 || path.indexOf('/pages/fire-starter') !== -1) isWinterProduct = true;
  /* homepage flame trigger removed 2026-07-03 — featured product is now granules (bug defense), flames stay on fire-product pages only */
  if (!isWinterProduct) return;

  var CDN = 'https://cdn.shopify.com/s/files/1/0660/5622/4985/files/';

  /* Detect Safari/iOS — needs HEVC alpha MOV, others use VP9 alpha WebM */
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
                 (/iPad|iPhone|iPod/.test(navigator.userAgent));
  var EXT = isSafari ? '.mov' : '.webm';

  var VIDEOS = {
    'low-spread': CDN + 'fire-lowspread-v4' + EXT,
    'campfire':   CDN + 'fire-campfire-v4' + EXT,
    'medium':     CDN + 'fire-medium-v4' + EXT,
    'fireplace':  CDN + 'fire-fireplace-v4' + EXT,
    'dramatic':   CDN + 'fire-dramatic-v4' + EXT
  };

  var preloaded = {};
  function preload(key) {
    if (preloaded[key]) return;
    var v = document.createElement('video');
    v.src = VIDEOS[key]; v.preload = 'auto'; v.muted = true;
    preloaded[key] = true;
  }

  function igniteElement(el, videoKey, w, h) {
    if (el._dtFireActive) return;
    el._dtFireActive = true;
    el.style.position = 'relative';
    el.style.overflow = 'visible';

    var vid = document.createElement('video');
    vid.src = VIDEOS[videoKey];
    vid.autoplay = true; vid.loop = true; vid.muted = true; vid.playsInline = true;
    vid.style.cssText = 'position:absolute;pointer-events:none;z-index:999;left:50%;transform:translateX(-50%);object-fit:cover;opacity:0;transition:opacity 0.3s ease;';
    vid.style.width = w + 'px';
    vid.style.height = h + 'px';
    vid.style.bottom = (el.offsetHeight - 5) + 'px';
    el.appendChild(vid);

    vid.offsetHeight;
    vid.style.opacity = '1';
    el.style.boxShadow = '0 -6px 20px rgba(255,100,0,0.3)';
    el.style.transition = 'box-shadow 0.3s ease';

    setTimeout(function() {
      vid.style.opacity = '0';
      el.style.boxShadow = '';
      setTimeout(function() { vid.remove(); el._dtFireActive = false; }, 400);
    }, 5000);
  }

  function initFire() {
    var pills = document.querySelectorAll('.product-form__input--pills label, .product-variant-options--pills label');
    var sizeMap = ['low-spread', 'campfire', 'medium', 'fireplace', 'dramatic'];
    var sizeW =  [100, 110, 120, 140, 200];
    var sizeH =  [80, 90, 95, 110, 150];
    pills.forEach(function(label, i) {
      if (label._dtFireBound) return;
      label._dtFireBound = true;
      var idx = Math.min(i, 4);
      preload(sizeMap[idx]);
      label.addEventListener('click', function() {
        igniteElement(label, sizeMap[idx], sizeW[idx], sizeH[idx]);
      });
    });

    var atcBtn = document.querySelector('[id^="ProductSubmitButton"]');
    if (atcBtn && !atcBtn._dtFireBound) {
      atcBtn._dtFireBound = true;
      preload('campfire');
      atcBtn.addEventListener('click', function() {
        igniteElement(atcBtn, 'campfire', 200, 140);
      });
    }

    var secBtn = document.querySelector('[id^="SectionAtcBtn"]');
    if (secBtn && !secBtn._dtFireBound) {
      secBtn._dtFireBound = true;
      preload('medium');
      secBtn.addEventListener('click', function() {
        igniteElement(secBtn, 'medium', 220, 150);
      });
    }

    var subBoxes = document.querySelectorAll('.subscription__box');
    subBoxes.forEach(function(box) {
      if (box._dtFireBound) return;
      box._dtFireBound = true;
      preload('fireplace');
      box.addEventListener('click', function() {
        igniteElement(box, 'fireplace', 250, 170);
      });
    });

    var buyNow = document.querySelector('.shopify-payment-button__button, [class*="shopify-payment-button"] button');
    if (buyNow && !buyNow._dtFireBound) {
      buyNow._dtFireBound = true;
      preload('dramatic');
      buyNow.addEventListener('click', function() {
        igniteElement(buyNow, 'dramatic', 380, 270);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFire);
  } else {
    initFire();
  }
  var obs = new MutationObserver(function() { setTimeout(initFire, 500); });
  obs.observe(document.body, { childList: true, subtree: true });
})();


/* ========== Static Phone Number in Header ========== */
(function() {
  function addPhone() {
    if (document.querySelector('.dt-header-phone')) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    
    var phone = document.createElement('a');
    phone.href = 'tel:2097422828';
    phone.className = 'dt-header-phone';
    phone.innerHTML = '📞 (209) 742-2828';
    phone.style.cssText = 'font-size:14px;font-weight:600;color:#2d5016;text-decoration:none;white-space:nowrap;margin-right:16px;display:flex;align-items:center;';
    icons.insertBefore(phone, icons.firstChild);
    
    var style = document.createElement('style');
    style.textContent = '@media (max-width: 989px) { .dt-header-phone { display: none !important; } }';
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addPhone);
  else addPhone();
})();

/* ========== LTL Freight Phone Number (43 cu ft Firewood) ========== */
(function() {
  var LTL_VARIANT_ID = '47585087553753';
  
  function init() {
    if (!window.location.pathname.includes('cedar-firewood') && 
        !window.location.pathname.includes('incense-cedar-firewood')) return;
    
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    
    var container = document.createElement('div');
    container.id = 'ltl-phone-container';
    container.style.cssText = 'display:none;margin:16px 0;padding:16px;background:#1a1a2e;border:2px solid #c9a84c;border-radius:8px;';
    container.innerHTML = 
      '<label for="ltl-phone" style="display:block;margin-bottom:8px;font-weight:600;color:#c9a84c;font-size:14px;">' +
      '\u{1F4DE} Phone Number (Required for Freight Delivery)</label>' +
      '<p style="margin-bottom:10px;font-size:13px;color:#ccc;line-height:1.4;">' +
      'Our freight carrier will call this number to schedule your pallet delivery.</p>' +
      '<input type="tel" id="ltl-phone" name="properties[Delivery Phone]" ' +
      'placeholder="(555) 123-4567" ' +
      'style="width:100%;padding:12px;border:1px solid #444;border-radius:6px;background:#0d0d1a;color:#fff;font-size:16px;">' +
      '<p id="ltl-phone-error" style="display:none;color:#ff4444;font-size:12px;margin-top:6px;">' +
      'Please enter a phone number so the freight company can schedule delivery.</p>';
    
    var buyBtn = form.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
    if (buyBtn && buyBtn.parentNode) {
      buyBtn.parentNode.insertBefore(container, buyBtn);
    } else {
      form.appendChild(container);
    }
    
    function getSelectedVariantId() {
      var hidden = form.querySelector('input[name="id"][type="hidden"]');
      if (hidden) return hidden.value;
      var sel = form.querySelector('select[name="id"]');
      if (sel) return sel.value;
      var radio = form.querySelector('input[name="id"]:checked');
      if (radio) return radio.value;
      return '';
    }
    
    function checkVariant() {
      var vid = getSelectedVariantId();
      var is43 = (vid === LTL_VARIANT_ID);
      container.style.display = is43 ? 'block' : 'none';
    }
    
    var observer = new MutationObserver(function() { setTimeout(checkVariant, 150); });
    observer.observe(form, { subtree: true, attributes: true, childList: true });
    form.querySelectorAll('input[type="radio"], select').forEach(function(el) {
      el.addEventListener('change', checkVariant);
    });
    setInterval(checkVariant, 1000);
    
    /* Intercept BOTH form submit AND fetch to /cart/add */
    function validatePhone() {
      var vid = getSelectedVariantId();
      if (vid !== LTL_VARIANT_ID) return true;
      var phone = document.getElementById('ltl-phone');
      var err = document.getElementById('ltl-phone-error');
      if (!phone || !phone.value || phone.value.replace(/\D/g, '').length < 7) {
        if (err) err.style.display = 'block';
        if (phone) { phone.style.borderColor = '#ff4444'; phone.focus(); }
        return false;
      }
      if (err) err.style.display = 'none';
      if (phone) phone.style.borderColor = '#444';
      return true;
    }
    
    /* Block form submit */
    form.addEventListener('submit', function(e) {
      if (!validatePhone()) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
    }, true);
    
    /* Block click on add-to-cart buttons */
    var addBtns = form.querySelectorAll('[name="add"], .product-form__submit, button[type="submit"]');
    addBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        if (!validatePhone()) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
      }, true);
    });
    
    /* Intercept fetch to /cart/add — inject phone as line item property */
    var origFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      if (typeof url === 'string' && url.includes('/cart/add')) {
        if (!validatePhone()) {
          return Promise.reject(new Error('Phone number required for freight delivery'));
        }
        /* Inject phone into the request body */
        var opts = arguments[1] || {};
        if (opts.body) {
          try {
            var body;
            if (opts.body instanceof FormData) {
              body = opts.body;
              var phone = document.getElementById('ltl-phone');
              var vid = getSelectedVariantId();
              if (vid === LTL_VARIANT_ID && phone && phone.value) {
                body.set('properties[Delivery Phone]', phone.value);
              }
            } else if (typeof opts.body === 'string') {
              body = JSON.parse(opts.body);
              var phone = document.getElementById('ltl-phone');
              var vid = getSelectedVariantId();
              if (vid === LTL_VARIANT_ID && phone && phone.value) {
                body.properties = body.properties || {};
                body.properties['Delivery Phone'] = phone.value;
                opts.body = JSON.stringify(body);
              }
            }
          } catch(e) {}
        }
      }
      return origFetch.apply(this, arguments);
    };
    
    setTimeout(checkVariant, 500);
  }
  
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();